<div class="flex-1 d-flex overflow-auto">
    <kui-table
        #table
        class="h-100"
        [selectionMode]="'single'"
        selectionColumn="id"
        [nowrap]="true"
        [rows]="rows"
        [cols]="cols"
        [resize]="false"
        [selection]="true"
        (onRowSelect)="onRowSelected($event)"
    >
    </kui-table>
</div>
@if (!errorMessage && rows) {
    <div class="border-top d-flex align-items-center" style="min-height: 35px">
        <div class="flex-1">
            <kui-paginate [page]="page" [total]="total" [perPage]="limit" [collapse]="true" (pageChanged)="onPageChanged($event)"></kui-paginate>
        </div>
        @if (!!handler?.visibleActions?.length) {
            <div class="pr-3 overflow-hidden">
                @if (handler.visibleActions.includes("add")) {
                    <kui-icon kui-action name="add" size="sm" class="ml-2" (click)="addClicked()"></kui-icon>
                }
                @if (handler.visibleActions.includes("delete")) {
                    <kui-icon kui-action name="delete" size="sm" class="ml-2" [class.disabled]="!selectedRow" (click)="deleteClicked()"></kui-icon>
                }
            </div>
        }
    </div>
}
